export function validateInputLength(input, minLength, maxLength, errorCallback) {
  if (input.length < minLength || input.length > maxLength) {
    errorCallback();
    return false;
  }

  return true;
}